export function FinDia(fecha) {
    const fechaFinDia = new Date(fecha).setHours(23,59,59,99)
    return (
        new Date(fechaFinDia)
    )
}